import { render, staticRenderFns } from "./strengthTest.vue?vue&type=template&id=3ccf4f4a&scoped=true"
import script from "./strengthTest.vue?vue&type=script&lang=js"
export * from "./strengthTest.vue?vue&type=script&lang=js"
import style0 from "./strengthTest.vue?vue&type=style&index=0&id=3ccf4f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf4f4a",
  null
  
)

export default component.exports